import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";

interface Testimonial1Props extends ComponentPropsWithRef<"div"> {
  content: ReactNode;
  styles?: Record<string, StyleValue>;
  userCard: ReactNode;
}

export const Testimonial1 = forwardRef<HTMLDivElement, Testimonial1Props>(
  ({ userCard, content, styles = {}, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles });

    return (
      <div
        ref={ref}
        className={classNames(
          "wb-bg-primary wb-flex wb-flex-col wb-gap-4 wb-rounded-[1.25rem] wb-p-[1.88rem]",
          className,
        )}
        style={inlineStyles}
        {...rest}
      >
        {userCard}
        {content}
      </div>
    );
  },
);
Testimonial1.displayName = "Testimonial1";
